import styled from 'styled-components';
import { ParticipantItem } from 'features/ParticipantItem';

export const ParticipantScrollableContainer = styled.div`
    height: 100%;
    overflow-y: auto;
`;

export const ParticipantsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: var(--layout-grid-gap);
    padding-right: 3px;
`;

export const ParticipantWrapper = styled.div`
    width: 100%;
`;

export const ViewerParticipant = styled(ParticipantItem)`
    flex-grow: 0;
    flex-shrink: 0;
    width: 100%;
`;
